import { useCloseOnboardingGuard } from 'modules/auth/components/CloseOnboardingBlockingModal/useCloseOnboardingGuard'
import { BlankPage } from 'modules/common/types/page'
import { PropsWithChildren } from 'react'
import { AuthenticatedPageGuard } from './AuthenticatedPageGuard/AuthenticatedPageGuard'
import { FullPageLoader } from './FullPageLoader/FullPageLoader'
import { NotAuthenticatedPageGuard } from './NotAuthenticatedPageGuard/NotAuthenticatedPageGuard'

interface Props {
  pageType: BlankPage['type']
}

export const AuthGuards = ({
  pageType,
  children,
}: PropsWithChildren<Props>) => {
  const { isBlocking } = useCloseOnboardingGuard()

  if (isBlocking) {
    return <FullPageLoader />
  }

  switch (pageType) {
    case 'authenticated':
      return <AuthenticatedPageGuard>{children}</AuthenticatedPageGuard>
    case 'notAuthenticated':
      return <NotAuthenticatedPageGuard>{children}</NotAuthenticatedPageGuard>
    case 'detached':
      return <>{children}</>
  }
}
